// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import layer from 'vue-layer-mobile'
import 'vue-layer-mobile/need/layer.css'
import iView from 'iview'
import 'iview/dist/styles/iview.css'
import router from './router'
import axios from 'axios'
import './assets/iconfont/iconfont.css'

axios.defaults.withCredentials = true
Vue.prototype.$axios = axios

Vue.use(iView)
Vue.use(layer)
Vue.config.productionTip = false

/* eslint-disable no-new */
const vue = new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})

window.$$vm = vue



// WEBPACK FOOTER //
// ./src/main.js